export enum OpportunityCostExperimentGroups {
  Control = 'control',
  VariantA = 'varianta',
  VariantB = 'variantb',
  VariantC = 'variantc',
}

export enum PriceFramingLanguageExperimentGroups {
  Control = 'control',
  VariantA = 'varianta',
  VariantB = 'variantb',
}

export enum TestimonialsIntegrationExperimentGroups {
  Control = 'control',
  Variant = 'variant',
}

export enum UpgradeModalExperimentGroups {
  // default multi step modal
  Control = 'control',
  // single page upgrade modal
  VariantA = 'varianta',
  // new lifestyle multi step modal
  VariantB = 'variantb',
}
